import React from "react";
import { ToastContainer } from "react-toastify";
import { AddSubCategory } from "../../../components/MasterSettings/SubCategory/AddSubCategory";
export const SubCategoryAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddSubCategory />
        </div>
      </div>
    </div>
  );
};